import { NextSeo } from 'next-seo';
import React from 'react';
import config from '../config';

const PageSeo = ({ title, description }) => {
  const subheading = `${config.siteName}`;
  const finalTitle = title ? `${title} - ${subheading}` : subheading;
  return <NextSeo title={finalTitle} description={description} />;
};

export default PageSeo;
